import CheckBox from 'components/elements/checkBox';
import { equalityArray } from 'lib/utils/helpers/equalityArray';
import get from 'lodash/get';
import { observer } from 'mobx-react';
import { FormEvent } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

interface Props<T>
  extends Omit<Partial<HTMLInputElement>, 'defaultValue' | 'value'> {
  name: string;
  data: T[];
  valueKey: keyof T;
  titleKey: keyof T;
  onChange?: (_value: (string | number)[]) => void;
  defaultValue?: number[];
}

function ArrayNumber<T>({
  data,
  titleKey,
  valueKey,
  name,
  ...props
}: Props<T>) {
  const methods = useFormContext();
  const allValues = data
    .map((item) => get(item, valueKey) as string | number)
    .filter((item) => item != -1);

  const onChangeHandler = (e: FormEvent<HTMLInputElement>, _value: any) => {
    const checked = e.currentTarget.checked;
    const targetValue = e.currentTarget.value;
    if (_value === null) {
      _value = [];
    }
    else if(typeof _value === "string") {
      _value = [_value];
    }
    let cloneData = _value.slice() as (number | string)[];

    const pIndex = cloneData.findIndex((val) => val === targetValue);

    if (checked) {
      if (targetValue === "-1") {
        cloneData = data.map((itemData) => get(itemData, valueKey));
      }
      else {
        cloneData.push(targetValue);
        if (equalityArray(allValues, cloneData)) {
          cloneData.push("-1");
        }
      }
    }
    else {
      if (targetValue === "-1") {
        cloneData = [];
      }
      else if (pIndex >= 0) {
        cloneData.splice(pIndex, 1);
        const allIndex = cloneData.findIndex((val) => val === "-1");
        if (allIndex >= 0) {
          cloneData.splice(allIndex, 1);
        }
      }
    }

    methods.setValue(name, cloneData, {
      shouldTouch: true,
      shouldValidate: true,
    });

    if (props.onChange) props.onChange(cloneData);
  };

  return (
    <Controller
      control={methods.control}
      defaultValue={props.defaultValue}
      name={name}
      render={({ field: { name: fieldName, value: _value } }) => (
        <>
          {data.map((item) => (
            <CheckBox
              name={fieldName}
              key={get(item, valueKey)}
              value={get(item, valueKey)}
              checked={
                _value && (_value as string[]).includes(get(item, valueKey))
              }
              onChange={(e) => onChangeHandler(e, _value)}
            >
              {get(item, titleKey)}
            </CheckBox>
          ))}
        </>
      )}
    />
  );
}

export default observer(ArrayNumber);
